import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { fetchTenantContentSettings } from "@/lib/utils/content-settings/tenant-content-settings-api";

export async function prefetchTenantContentSettings(
  queryClient: QueryClient,
  tenantId: number,
) {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.TenantContentSettings, tenantId],
    queryFn: () => fetchTenantContentSettings(tenantId),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
